import { render } from "./DeviceGroupSection.vue?vue&type=template&id=21d77ce7"
import script from "./DeviceGroupSection.vue?vue&type=script&lang=js"
export * from "./DeviceGroupSection.vue?vue&type=script&lang=js"
script.render = render

export default script